import type { PeriodKind } from '../lib/types';

interface TabBarProps {
  value: PeriodKind;
  onChange: (next: PeriodKind) => void;
}

const TABS: Array<{ key: PeriodKind; label: string }> = [
  { key: 'today', label: '今日' },
  { key: 'week', label: '今週' },
  { key: 'month', label: '今月' },
];

export function TabBar({ value, onChange }: TabBarProps) {
  return (
    <nav className="max-w-device w-full mx-auto px-4 pt-3">
      <div role="tablist"
           className="flex rounded-full bg-ink-100 dark:bg-ink-800 p-1 text-sm shadow-inner shadow-ink-900/5">
        {TABS.map((t) => {
          const active = t.key === value;
          return (
            <button
              key={t.key}
              role="tab"
              aria-selected={active}
              onClick={() => onChange(t.key)}
              className={
                'flex-1 py-2 rounded-full font-semibold transition-all duration-150 ' +
                (active
                  ? 'bg-white dark:bg-ink-700 text-ink-900 dark:text-ink-50 shadow-sm shadow-ink-900/10'
                  : 'text-ink-500 dark:text-ink-300 hover:text-ink-700 dark:hover:text-ink-100')
              }
            >
              {t.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
